import { useMemo } from 'react'

import { useZervantSettings } from '../../../../invoicingSettings/hooks/useZervantSettings'
import { getPrimaryTradeName } from '../../../../invoicingSettings/utils/getPrimaryTradeName'
import { SendAsEmailModalVariant } from '../../../enums/sendAsEmailModalVariant'
import { ZervantLocale } from '../../../enums/zervantLocale'
import { useFetchInvoiceEmailTemplate } from '../../../hooks/useFetchInvoiceEmailTemplate'
import { useSendAsEmailModal } from '../contexts/sendAsEmailModalContext'

const PAYMENT_REMINDER_TEMPLATE_TYPE = 'reminder'

const removeLineBreaks = (message: string) => {
  return message?.replace(/<br>|<br\/>/g, '\n')
}

export const useInvoiceEmailMessage = (variant: SendAsEmailModalVariant) => {
  const { data: zervantSettings, isLoading: isLoadingZervantSettings } = useZervantSettings()
  const { documentLocale, documentType } = useSendAsEmailModal()

  const emailTemplateLocale = documentLocale || ZervantLocale.EN_GB
  const emailTemplateType = variant === SendAsEmailModalVariant.Invoice ? documentType : PAYMENT_REMINDER_TEMPLATE_TYPE

  const { invoiceEmailTemplate, isLoading: isLoadingTemplate } = useFetchInvoiceEmailTemplate(
    emailTemplateType,
    emailTemplateLocale,
  )

  const isLoading = isLoadingZervantSettings || isLoadingTemplate

  const invoiceEmailMessage = useMemo(() => {
    const invoiceEmailTemplateBody = invoiceEmailTemplate?.body

    if (!invoiceEmailTemplateBody) {
      return undefined
    }

    const formattedMessage = removeLineBreaks(invoiceEmailTemplateBody)
    const tradeName = getPrimaryTradeName(zervantSettings?.values?.company?.tradeNames)?.name

    if (invoiceEmailTemplate?.isDefault && !!tradeName) {
      return `${formattedMessage}${tradeName}`
    } else {
      return formattedMessage
    }
  }, [invoiceEmailTemplate, zervantSettings?.values?.company?.tradeNames])

  return { message: invoiceEmailMessage, isLoading }
}
